<template>
    <div class="uploader">
        <img class="selected-image" :src="imagePath" @click="presentActionSheet" />
        <ion-spinner v-if="isLoading" color="primary"></ion-spinner>
        <ion-input style="display: none;" type="file" multiple="true" :path="uploadPath" @ionChange="onFilesSelected" ref="fileInput" />
        <ion-button v-if="!isLoading" class="upload-button" expand="block" @click="chooseFile">{{ $t('signup.pickFile') }}</ion-button>
    </div>
</template>

<script>
import AxiosController from '@/controllers/AxiosController'
import { constants } from '../constants'
import { mapGetters } from 'vuex'

export default {
    name: 'Uploader',
    props: ['path', 'defaultImgPath', 'position'],
    computed: mapGetters(['user']),
    data() {
        return {
            selectedFile: null,
            imagePath: require('../assets/imgupload.png'),
            uploadPath: null,
            isLoading: false
        }
    },
    mounted() {
        if (this.defaultImgPath) {
            this.imagePath = `${constants.assetsUri}/${this.defaultImgPath}`
        }
    },
    methods: {
        chooseFile: function() {
            this.$refs.fileInput.children[0].click()
        },
        onFilesSelected: function(e) {
            if (e.srcElement.childNodes[0].files[0]) {
                this.isLoading = true
                this.selectedFile = e.srcElement.childNodes[0].files[0]
                const fd = new FormData()
                fd.append('uploaded-file', this.selectedFile)
                fd.set('position', this.position)
                AxiosController.post(this.path, fd).then(res => {
                    this.user.images = res.data.images
                    this.$store.dispatch('setUser', this.user)
                    const slotImage = res.data.images.find(image => image.position == this.position)
                    this.imagePath = `${constants.assetsUri}/${slotImage.path}`
                    this.isLoading = false
                })
            }
        },
        presentActionSheet: function() {
            if (this.imagePath != require('../assets/imgupload.png')) {
                return this.$ionic.actionSheetController
                    .create({
                        buttons: [
                            {
                                text: this.$t('privateProfile.removePicture'),
                                role: 'destructive',
                                icon: 'trash',
                                handler: () => {
                                    this.removePicture()
                                }
                            },
                            {
                                text: this.$t('privateProfile.changePicture'),
                                icon: 'swap',
                                handler: () => {
                                    this.chooseFile()
                                }
                            },
                            {
                                text: this.$t('master.cancel'),
                                icon: 'close',
                                role: 'cancel'
                            }
                        ]
                    })
                    .then(a => a.present())
            }
        },
        removePicture: function() {
            this.isLoading = true
            AxiosController.post('/delete-picture', { position: this.position })
                .then(res => {
                    this.imagePath = require('../assets/imgupload.png')
                    this.$store.dispatch('setUser', res.data)
                    this.isLoading = false
                })
                .catch(err => console.log(err))
        }
    }
}
</script>

<style lang="scss" scoped>
.uploader {
    padding: 0 5px;

    .selected-image {
        padding: 10px;
    }

    ion-button {
        --border-radius: 20px;
        --background: #90c99c;
        height: 25px;
        --color: #000000;
    }
}

@media (min-width: 768px) {
    .upload-button {
        width: 90%;
        margin: 4px 5%;
        height: 30px;
    }
}
</style>
